
import React from 'react';
import { Auth } from './Auth';
import { LanguageService } from './LanguageService';
import axios from 'axios';
import { notification } from 'antd';
import { refreshToken } from '../actions/LoginActions';
import store from '../index';
import { Utils } from './Utlis';


// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    const authData = Auth.fillAndGetData();
    const selecteLanguage = LanguageService.getSelectedLanguage();

    if (config.headers['grant_type'] !== 'refresh_token') {
        //Set access token
        if (authData && authData.token) {
            config.headers['Authorization'] = 'Bearer ' + authData.token;
            config.headers['mainPartnerId'] = store.getState().affiliates.mainPartnerId;
            config.headers['affiliateId'] = store.getState().affiliates.affiliateId;
            config.headers['TimeZone'] = Utils.getTimeZone();
        }

        //Set selected language
        if (selecteLanguage) {
            config.headers['accept-language'] = selecteLanguage;
        }

        //Set default content type
        if (!config.headers['Content-Type'] || config.headers['Content-Type'] === 'text/plain;charset=UTF-8') {
            config.headers['Content-Type'] = 'application/json';
        }
    } else {
        delete config.headers['grant_type'];
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error && error.response && error.response.status === 401) {
        const authData = Auth.fillAndGetData();

        const { config } = error;
        const originalRequest = config;

        if (authData && authData.refreshToken) {
            const req = refreshToken(authData, originalRequest, Auth);
            console.log(req);
            return req;
        } else {
            Auth.invalidateSession();
            window.location.reload();
        }
    } else if (error && error.response && error.response.status >= 400) { // If error occur
        const result = error.response && error.response.data;

        if (result && result.Code && result.Message) {
            let description = '';

            if (result.Errors && !(Object.entries(result.Errors).length === 0 && result.Errors.constructor === Object)) {
                let errorArray = Object.values(result.Errors);
                description = errorArray.map((elm) =>
                    <p>{elm}</p>
                );
            }

            notification.error({
                key: 'networkError',
                placement: 'bottomRight',
                duration: 5,
                className: 'ta--notification-error',
                // message: result.Message,
                message: description || result.Message
            });
        }
    }
    return Promise.reject(error);
});


// WEBPACK FOOTER //
// ./src/services/Interceptor.js